import { createContext, useContext, useState, useCallback } from "react";

const CartContext = createContext(null);

const readJSON = (key) => {
  try {
    const v = sessionStorage.getItem(key);
    return v ? JSON.parse(v) : null;
  } catch (e) {
    return null;
  }
};

export const CartProvider = ({ children }) => {
  const [plan, setPlan] = useState(() => readJSON("ct-plan"));
  const [phone, setPhone] = useState(() => readJSON("ct-phone"));

  const selectPlan = useCallback((p) => {
    setPlan(p);
    try {
      sessionStorage.setItem("ct-plan", JSON.stringify(p));
    } catch (e) {}
  }, []);

  const selectPhone = useCallback((p) => {
    setPhone(p);
    try {
      sessionStorage.setItem("ct-phone", JSON.stringify(p));
    } catch (e) {}
  }, []);

  const removePhone = useCallback(() => {
    setPhone(null);
    sessionStorage.removeItem("ct-phone");
  }, []);

  const clearCart = useCallback(() => {
    setPlan(null);
    setPhone(null);
    sessionStorage.removeItem("ct-plan");
    sessionStorage.removeItem("ct-phone");
  }, []);

  const total = (plan ? Number(plan.price) : 0) + (phone ? Number(phone.price) : 0);

  return (
    <CartContext.Provider
      value={{ plan, phone, selectPlan, selectPhone, removePhone, clearCart, total }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
